<script>
import { Upload } from 'ant-design-vue'
export default {
  props: ['value', 'item', 'mode', 'styles'],
  data() {
    return {}
  },
  methods: {
    getImgUrl(list) {
      const arr = []
      const { url } = JSON.parse(localStorage.getItem('qiniu-v2')) || {}
      list.forEach(e => {
        if (e.status == 'done') {
          if (e.fname) {
            arr.push(url + e.fname)
          } else if (e.url) {
            arr.push(e.url)
          } else {
            if (e.response && e.response.fname) {
              arr.push(url + e.response.fname)
            }
          }
        }
      })
      return arr.join(',')
    },
    getFileList(url) {
      if (Array.isArray(url)) return url
      if (!url) return []
      return url
        .split(',')
        .filter(e => e)
        .map(e => {
          if (!e) return
          const name = e.split('?')[0].split('/')[3]
          return {
            uid: 'vc-upload-' + name,
            name,
            status: 'done',
            url: e,
            thumbUrl: e
          }
        })
    },
    handleChange(data, value) {
      if (data.file.status == 'uploading') {
        this.$emit('change', data.fileList)
      } else {
        this.$emit('change', this.getImgUrl(data.fileList))
      }
      // 替换前一个
      if (data.fileList.length > 1) {
        data.fileList.splice(0, 1)
      }
    },
    beforeUpload(file, fileList) {
      const isZip = file.name.includes('apk')
      if (!isZip) {
        this.$message.warning('文件格式不正确，重新拖到此处上传')
        return false
      }
      return isZip
    }
  },
  render() {
    const { token } = JSON.parse(localStorage.getItem('qiniu-v2')) || {}
    return (
      <Upload
        name="file"
        action="//upload.qiniup.com/"
        fileList={this.getFileList(this.value)}
        data={{ token }}
        onChange={this.handleChange}
        beforeUpload={this.beforeUpload}
      >
        <a-button>
          <a-icon type="upload" /> Upload files
        </a-button>
      </Upload>
    )
  }
}
</script>
<style lang="less" scoped>
/deep/.ant-upload.ant-upload-drag {
  height: 120px;
  border: 1px dashed #ddd;
  background-color: #fff;
  border-radius: 10px;
}
.boxx {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  span {
    font-family: PingFang-SC-ExtraLight, 'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
    color: rgb(81, 90, 110);
  }

  .img_box {
    width: 50px;
  }
}
</style>
